var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filters-list',{attrs:{"addable":_vm.addable,"editable":_vm.editable,"name":_vm.name,"required":_vm.required},on:{"add":_vm.showCreateFilterModal,"edit":_vm.showEditFilterModal,"delete":_vm.showDeleteFilterModal},model:{value:(_vm.filters),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"filters"}})
}
var staticRenderFns = []

export { render, staticRenderFns }